import html2canvas from 'html2canvas';

export const handlePrint = async () => {
  try {
    const element = document.getElementById('printableData');

    if (!element) {
      console.error('Элемент для печати не найден');
      return;
    }

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
    });

    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      console.error('Не удалось открыть окно печати (возможно, блокируется браузером)');
      return;
    }

    const html = `
		<!DOCTYPE html>
		<html>
		  <head>
			<title>Печать</title>
			<style>
			  body { margin: 0; padding: 0; }
			  img { max-width: 100%; height: auto; }
			</style>
		  </head>
		  <body>
			<img src="${canvas.toDataURL('image/png')}" />
		  </body>
		</html>
	  `;

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      setTimeout(() => printWindow.close(), 500);
    };
  } catch (error) {
    console.error('Ошибка при печати:', error);
  }
};
